export const BASE_API_URL = 'https://ppk-node-sql.herokuapp.com/api/';
// export const BASE_API_URL = 'http://localhost:5001/api/';
// export const BASE_URL = 'http://localhost:5001/';
export const BASE_URL = 'https://ppk-node-sql.herokuapp.com/';
